<template>
  <v-row>     
     <v-col cols="12" sm="12" md="3" lg="2" >     
      <div class="simple-data-control-container">
        <div class="simple-data-response-number mb-1">{{responseCount}}</div>
        <div class="simple-data-control-description">{{ $t("poll.lblResponses") }}</div>
      </div>
    </v-col>
    <v-col cols="12" sm="12" md="9" lg="10" > 
      <div class="simple-data-control-container">
       <div v-if="question.options.text==='Star'" class="simple-data-response-number mb-1">
         <v-rating large color="warning" readonly half-increments background-color="secondary lighten-4" :length="question.options.value" :value="ratingValue">
         </v-rating>
       </div>
       <div v-else class="simple-data-response-number mb-1">{{avgRating}}</div>
        
        <div v-if="question.options.text==='Star'" class="simple-data-control-description">{{avgRating}} {{ $t("poll.lblAverageRating") }}</div>
         <div v-else class="simple-data-control-description">{{ $t("poll.lblAverageNumber") }}</div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "RatingResponse",
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    ratingData: {
      type: Object,
      default: () => {},
    },
  },
  computed:{
    ratingValue(){
        return this.ratingData?Number(this.ratingData.avg):0.0;   
    },
    responseCount(){
      return this.ratingData?this.ratingData.count:0;
    },
    avgRating(){
       return this.ratingData?this.ratingData.avg:0.0;
    }
  },
};
</script>

<style scoped>
.simple-data-control-container {
  position: relative;
  height: 81px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
}
.simple-data-response-number {
  white-space: nowrap;
  color: #324154;
  font-size: 28px;
}

.simple-data-control-description {
  white-space: nowrap;
  color: #595959;
  font-size: 15px;
}
</style>